<gipi-abstract>
    <gipi-toolbar id="toolbarListClientClassificationList"
                  label="Consulta de classificações de cliente">
    </gipi-toolbar>
    <div fxLayout="row"
         fxLayout.lt-md="column"
         fxLayoutAlign="start center"
         fxLayoutGap="16px">
        <gipi-input-text placeholder="Pesquisar"
                         showSuffix="true"
                         [(ngModel)]="filter.researchField"
                         (keydown.enter)="findAll()"
                         fxFlex="50"
                         fxFlex.lt-md="100">
            <gipi-button tooltip="Pesquisar"
                         gipi-icon
                         suffix
                         id="btnSearch"
                         icon="search"
                         [forInput]="true"
                         (click)="findAll()">
            </gipi-button>
        </gipi-input-text>
    </div>

    <gipi-mat-table [columns]="columns"
                    [rows]="page.content"
                    [sort]="true"
                    [paginator]="true"
                    [pageIndex]="page.number"
                    [pageLength]="page.totalElements"
                    [loading]="loading"
                    (pageChange)="findAll($event)"
                    (rowChange)="rowChange($event)">
    </gipi-mat-table>

    <div mat-dialog-actions
         fxLayout="row wrap"
         fxLayout.lt-md="column wrap"
         fxLayoutAlign="end end"
         fxLayoutGap="16px">
        <gipi-button label="Confirmar"
                     gipi-primary
                     id="btnConfirm"
                     name="btnConfirm"
                     (click)="confirm()"
                     [disabled]="entitiesSelectedIsEmpty || loading"
                     [loading]="loading"
                     fxFlex="20"
                     fxFlex.lt-md="100">
        </gipi-button>
        <gipi-button label="Voltar"
                     gipi-secondary
                     id="btnReturn"
                     name="btnReturn"
                     (click)="close()"
                     fxFlex="20"
                     fxFlex.lt-md="100">
        </gipi-button>
    </div>
</gipi-abstract>

<ng-template #checkboxAllTemplate
             let-row>
    <gipi-checkbox gipi-primary
                   [(ngModel)]="allRowsChecked"
                   [checked]="allRowsChecked"
                   [(indeterminate)]="indeterminateRowsChecked"
                   (change)="checkAllRows()">
    </gipi-checkbox>
</ng-template>

<ng-template #checkboxRowTemplate
             let-row>
    <gipi-checkbox gipi-secondary
                   [(ngModel)]="row.selected"
                   [checked]="row.selected"
                   (change)="selectRow(row, true)">
    </gipi-checkbox>
</ng-template>